import { isIOS } from "@moim/common";
import { createGlobalStyle, css } from "styled-components";

const GlobalStyle = createGlobalStyle`

html {
  -webkit-overflow-scrolling: touch;
  font-size: 10px;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
}


* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
* {
  &,
  &::before,
  &::after {
    box-sizing: inherit;
  }
  &:focus {
    outline: 0;
  }
  -webkit-tap-highlight-color:transparent;
}

html, body, #root {
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colorV2.colorSet.white1000};
}

body, p, div, span, h1, h2, h3, h4, h5, h6, a, li, td, th, label, button, input, select, textarea {
  color: ${props => props.theme.colorV2.colorSet.grey1000};
}

a {
text-decoration: none;
}

button,
hr,
input {
  overflow: visible;
}
html {
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}
body {
  margin: 0;
  -webkit-overflow-scrolling: touch;
  letter-spacing: "normal";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "AppleSDGothicNeo",
    "Noto Sans KR", "Noto Sans JP", "Malgun Gothic", "맑은 고딕", dotum, "돋움", system-ui, Roboto,
    arial, "Helvetica Neue", sans-serif
}
// NOTE: telegram rule
body {
  ${() => {
    if (isIOS()) {
      return css`
        height: calc(
          var(--tg-viewport-stable-height, 100%) -
            calc(
              var(--tg-safe-area-inset-top, 0px) +
                var(--tg-safe-area-inset-bottom, 0px)
            )
        );
      `;
    }
    return css`
      height: 100%;
      margin-top: var(--tg-content-safe-area-inset-top, 0px);
    `;
  }}
}


p,
  figcaption,
  menu,
  article,
  aside,
  details,
  figure,
  footer,
  header,
  main,
  nav,
  section,
  summary {
    display: block;
    margin: 0;
  }
  audio,
  canvas,
  progress,
  video {
    display: inline-block;
  }
  audio:not([controls]) {
    display: none;
    height: 0;
  }
  [hidden],
  template {
    display: none;
  }
  a {
    -webkit-text-decoration-skip: objects;
    text-decoration: inherit;
    color: inherit;
  }
  a:active,
  a:hover {
    outline-width: 0;
  }
  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
  }
  b,
  strong {
    font-weight: bolder;
  }
  dfn {
    font-style: italic;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: 100%;
    margin: 0;
  }

  mark {
    background-color: #ff0;
    color: #000;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  img {
    border-style: none;
  }
  svg:not(:root) {
    overflow: hidden;
  }
  code,
  kbd,
  pre,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  hr {
    box-sizing: content-box;
    height: 0;
  }
  button,
  input,
  select,
  textarea {
    font: inherit;
    margin: 0;
    padding: 0;
    background-color: transparent;
  }
  optgroup {
    font-weight: 700;
  }
  button,
  select {
    text-transform: none;
  }
  button {
    -webkit-appearance: none;
    background-color: transparent;
    border: 0;
  }

  [type="submit"],
  [type="reset"],
  button,
  label,
  [role="button"],
  [type="button"],
  a {
    cursor: pointer;
  }

  [type="submit"][disabled],
  [type="reset"][disabled],
  button[disabled],
  label[disabled],
  [type="button"][disabled],
  [role="button"][disabled] {
    cursor: not-allowed;
  }

`;

export default GlobalStyle;
